import EventEmitter from 'events';

const CHANGE_EVENT = 'CHANGE';

/** Skeleton for a Store extending Event Emitter. All
  * stores for the demo to extend this.
  */
class BaseStore extends EventEmitter {

  addChangeListener(cb) {
    this.on(CHANGE_EVENT, cb);
  }

  removeChangeListener(cb) {
    this.removeListener(CHANGE_EVENT, cb);
  }

  emitChange(...args) {
    this.emit(CHANGE_EVENT, ...args);
  }
}

export default BaseStore;
